import SpreadsheetFontSizeDropdown from './SpreadsheetFontSizeDropdown';

export default SpreadsheetFontSizeDropdown;